const config = { attributes: true, childList: true, subtree: true };
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      const hasVariantQuery = window.location.href.includes('/products/');
      if (hasVariantQuery) {
        const wrongLinkElement = document.querySelectorAll('a[href="/account/login?checkout_url=current_product"]')
        for (let index = 0; index < wrongLinkElement.length; index++) {
          wrongLinkElement[index].href = wrongLinkElement[index].href.replace('checkout_url=current_product', `checkout_url=${encodeURI(window.location.href)}`)
        }
      }
    } else if (mutation.type === "attributes") {
      console.log(`The ${mutation.attributeName} attribute was modified.`);
    }
  }
};
const observer = new MutationObserver(callback);
observer.observe(document.body, config);